import React, { useState, useRef } from 'react'
import defaultProfile from '../../img/defaultProfile.png'
import './PostShare.css'
import { UilScenery } from "@iconscout/react-unicons"
import { UilPlayCircle } from "@iconscout/react-unicons"
import { UilLocationPoint } from "@iconscout/react-unicons"
import { UilSchedule } from "@iconscout/react-unicons"
import { UilTimes } from "@iconscout/react-unicons"
import { useSelector, useDispatch } from 'react-redux'
import {uploadPost} from '../../actions/uploadActions'

const PostShare = () => {
    const loading = useSelector((state) => state.postReducer.uploading);
    const [image, setImage] = useState(null);
    const [imageUrl, setImageUrl] = useState("");
    const [video, setVideo] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const imageRef = useRef();
    const videoRef = useRef();
    const desc = useRef();
    const { user } = useSelector((state) => state.authReducer.authData);
    const dispatch = useDispatch();
    

    const reset = () => {
        setImage(null);
        setVideo(null);
        desc.current.value ="";
    }

    const onImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            setImage(img);
        }
    }

    const onVideoChange = (e) => {
        if(e.target.files && e.target.files[0]){
            const vid = e.target.files[0];
            setVideo(vid);
            
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const newPost = {
            userId: user._id,
            desc: desc.current.value,
        }
        
        if (image) {
            const data = new FormData();
            data.append("file", image);
            data.append("upload_preset", "supertweet");
            data.append("cloud_name", "dwla5abuc");
            fetch("https://api.cloudinary.com/v1_1/dwla5abuc/image/upload", { 
                method: "post",
                body: data
            })
            .then(res => res.json())
            .then(resdata => {
                resdata ? setImageUrl(resdata.secure_url): console.log("fetching...");
            })
            .catch(error => {
                console.log(error);
            })

            setTimeout(()=>{
                newPost.image = imageUrl;
                dispatch(uploadPost(newPost));
            }, 7000)
            
                
        } else if(video){
            const data = new FormData();
            data.append("file", video);
            data.append("upload_preset", "supertweet");
            data.append("cloud_name", "dwla5abuc");
            fetch("https://api.cloudinary.com/v1_1/dwla5abuc/video/upload", { 
                method: "post",
                body: data
            })
            .then((res) => res.json())
            .then(data => {
                data ? setVideoUrl(data.secure_url) : console.log("fetching...");;  
            })
            .catch(error => {
                console.log(error);
            })
            
            setTimeout(() => {
                newPost.video = videoUrl;
                dispatch(uploadPost(newPost));
            }, 8000);
              
            
        } else {
            dispatch(uploadPost(newPost))
        }

        setIsFetching(prev=> !prev);

        setTimeout(() => {
            setIsFetching(prev=> !prev);
        }, 10000);
        
        reset();
    }

    return (
        <div className='PostShare'>
            <img src={user.profilePicture ? user.profilePicture : defaultProfile} alt='' />
            <div>
                <input ref={desc} required type="text" placeholder="What's happening" />
                <div className='postOptions'>
                    <div className='option' style={{ color: "var(--photo)" }} onClick={() => imageRef.current.click()}>
                        <UilScenery />
                        Photo
                    </div>
                    <div className='option' style={{ color: "var(--video)" }} onClick={() => videoRef.current.click()}>
                        <UilPlayCircle />
                        Video
                    </div>
                    <div className='option' style={{ color: "var(--location)" }}>
                        <UilLocationPoint />
                        Location
                    </div>
                    <div className='option' style={{ color: "var(--schedule)" }}>
                        <UilSchedule />
                        Schedule
                    </div>
                    <button className='button ps-button'
                        onClick={handleSubmit}
                        disabled={loading}>
                        {loading? "uploading" : "Share"}
                    </button>
                    <div style={{ display: "none" }}>
                        <input type="file" name="myImage" ref={imageRef} onChange={onImageChange} />
                        <input type="file" name="myVideo" ref={videoRef} onChange={onVideoChange} />
                    </div>
                </div>
                {image && (
                    <div className='previewImage'>
                        <UilTimes onClick={() => setImage(null)} />
                        <img src={URL.createObjectURL(image)} alt='' />
                    </div>
                )}
                {video && (
                    <div className='previewVideo'>
                        <UilTimes onClick={() => setVideo(null)} />
                        <video width="750" height="500" controls >
                            <source src={URL.createObjectURL(video)} type="video/mp4"/>
                        </video>
                    </div>
                )}
                {isFetching && (
                    <div>
                        <h4>Please wait,while loading...</h4>
                    </div>
                )}
            </div>

        </div>
    )
}

export default PostShare